import {
    React,
    useEffect,
    useState,
    useSelector,
    Fragment,
    memo,
} from '../../../imports/generalImport';
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    Box,
    Divider,
    Chip,
    Stack,
} from '../../../imports/muiImport';
import { dateChanger } from '../../../shared/extra';
import MobileVouchersViewButton from './MobileVouchersViewButton';

function MobileOrderCard({ ordersData, showVoucher = false }) {
    const orders = Array.isArray(ordersData) ? ordersData : [];

    const getStatusColorCode = (status) => {
        switch (status) {
            case 'Failure':
                return {
                    color: '#fb0000cf',
                    backgroundColor: '#ff000045',
                    boxShadow: '#ff000045',
                };
            case 'Success':
                return {
                    color: '#034818',
                    backgroundColor: '#a6f5be',
                    boxShadow: '#0d5523',
                };
            default:
                return {
                    color: '#fff',
                    // backgroundColor: "#0080a6",
                    // boxShadow: "#c7f2ff"
                    backgroundColor: '#FF9843',
                    boxShadow: '#FDFFAB',
                };
        }
    };

    if (orders?.length >= 1) {
        return (
            <Fragment>
                {orders?.map((item) => {
                    const statusColorCode = getStatusColorCode(item?.status);
                    return (
                        <Card
                            key={`orderId-${item?.id}`}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                py: 1,
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                borderRadius: 3,
                                mb: 3,
                            }}
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'row', px: 1 }}>
                                <CardMedia
                                    component="img"
                                    loading="lazy"
                                    sx={{
                                        width: 90,
                                        height: 60,
                                        borderRadius: 2,
                                        boxShadow: 0,
                                    }}
                                    image={item?.items?.[0]?.product?.image}
                                    alt={`${item?.product?.title}-image`}
                                />


                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ flex: '1 0 auto', py: 0 }}>
                                        <Typography
                                            component="div"
                                            variant="subtitle1"
                                            sx={{
                                                color: 'textprimary.main',
                                                fontWeight: 400,
                                            }}
                                        >
                                            Order Id :{' '}
                                            <Typography
                                                component="span"
                                                variant="subtitle1"
                                                sx={{
                                                    color: 'secondary.main',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {item?.orderNumber}
                                            </Typography>
                                        </Typography>
                                        <Typography
                                            variant="subtitle1"
                                            component="div"
                                            sx={{
                                                fontWeight: 500,
                                                color: 'primary.main',
                                            }}
                                        >
                                            {item?.items?.[0]?.product?.name}
                                        </Typography>
                                        <Typography variant="subtitle1" color="primary.main" component="div">
                                            Quantity :{' '}
                                            <Typography
                                                component="span"
                                                variant="subtitle1"
                                                sx={{
                                                    color: 'secondary.main',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {item?.items?.[0]?.quantity}
                                            </Typography>
                                        </Typography>
                                    </CardContent>
                                </Box>

                                {showVoucher && item?.status === 'COMPLETED' && (
                                    <MobileVouchersViewButton voucherData={item} />
                                )}
                            </Box>

                            <Divider
                                sx={{
                                    borderStyle: 'dashed',
                                    borderColor: 'primary.main',
                                }}
                            />

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    px: '4px',
                                    mt: 1,
                                }}
                            >
                                <Chip
                                    label={dateChanger(item?.createdAt)}
                                    sx={{
                                        color: 'primary.main',
                                        backgroundColor: '#d3eff7',
                                        fontWeight: 500,
                                        fontSize: '13.5px',
                                        borderRadius: 2,
                                        boxShadow: 'inset 0 0 10px #def8ff, 0 0 10px #def8ff',
                                    }}
                                />

                                <Divider
                                    orientation="vertical"
                                    sx={{
                                        height: 32,
                                    }}
                                />

                                <Chip
                                    label={`₹${item?.items?.[0]?.denomination?.amount || 0}`}
                                    sx={{
                                        color: 'primary.main',
                                        backgroundColor: '#deebff',
                                        fontWeight: 600,
                                        fontSize: '13.5px',
                                        borderRadius: 2,
                                        boxShadow: 'inset 0 0 10px #deebff, 0 0 10px #deebff',
                                        px: '4px',
                                    }}
                                />

                                <Divider
                                    orientation="vertical"
                                    sx={{
                                        height: 32,
                                    }}
                                />

                                <Chip
                                    label={item?.status?.status}
                                    sx={{
                                        color: statusColorCode.color,
                                        backgroundColor: statusColorCode.backgroundColor,
                                        fontWeight: 600,
                                        fontSize: '11.5px',
                                        borderRadius: 2,
                                        boxShadow: `inset 0 0 10px ${statusColorCode.boxShadow}, 0 0 10px #F8EDED`,
                                        px: '4px',
                                    }}
                                />
                            </Box>
                        </Card>
                    );
                })}
            </Fragment>
        );
    } else {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    backgroundColor: '#fff',
                    color: 'primary.main',
                    fontWeight: 600,
                    fontSize: '1.2rem',
                }}
            >
                No Orders Data Found
            </Box>
        );
    }
}

export default memo(MobileOrderCard);
